// extracted by mini-css-extract-plugin
export var container_info = "TextSectionNews-module--container_info--21d17";
export var container_info_text = "TextSectionNews-module--container_info_text--4a455";
export var container_socials = "TextSectionNews-module--container_socials--a7050";
export var procedureDetail = "TextSectionNews-module--procedureDetail--12f4a";
export var procedureDetailContainer = "TextSectionNews-module--procedureDetailContainer--80d92";
export var stepsContainer = "TextSectionNews-module--stepsContainer--bfef6";